import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ReactiveStatel8ixobo86msn as ReactiveState,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
} from '../core/ReactiveState.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
} from '../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_waitForNotNull(_this__u8e3s4) {
  return new (WaitForNotNull())(_this__u8e3s4);
}
var WaitForNotNullClass;
function WaitForNotNull() {
  if (WaitForNotNullClass === VOID) {
    class $ {
      constructor(wraps) {
        this.wraps_1 = wraps;
      }
      get_state_wc71uu_k$() {
        var tmp;
        if (_ReactiveState___get_raw__impl__92ipya(this.wraps_1.get_state_wc71uu_k$()) == null) {
          tmp = Companion_getInstance().notReady_1;
        } else {
          var tmp_0 = this.wraps_1.get_state_wc71uu_k$();
          tmp = new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
        }
        return tmp;
      }
      addListener_6y9mct_k$(listener) {
        return this.wraps_1.addListener_6y9mct_k$(listener);
      }
      hashCode() {
        return hashCode(this.wraps_1) + 1 | 0;
      }
      equals(other) {
        var tmp;
        if (other instanceof WaitForNotNull()) {
          tmp = equals(this.wraps_1, other.wraps_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, 'WaitForNotNull', VOID, VOID, [Reactive()]);
    WaitForNotNullClass = $;
  }
  return WaitForNotNullClass;
}
//region block: exports
export {
  get_waitForNotNull as get_waitForNotNull1jl9mx6el51tq,
};
//endregion

//# sourceMappingURL=WaitForNotNull.mjs.map
